"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineAutocompleteCellFactory = void 0;
const react_1 = __importStar(require("react"));
const form_autocomplete_1 = require("../../../composite/form/fields/form-autocomplete");
const inline_table_context_1 = require("../inline-table-context");
function useInlineAutocompleteCellFactory(props) {
    return (0, react_1.useMemo)(() => function InlineCell(tableFieldProps) {
        return (react_1.default.createElement(InlineAutocompleteCell, { inlineProps: props, tableFieldProps: tableFieldProps }));
    }, [props]);
}
exports.useInlineAutocompleteCellFactory = useInlineAutocompleteCellFactory;
function InlineAutocompleteCell({ inlineProps, tableFieldProps, }) {
    const { disabled: tableDisabled } = (0, react_1.useContext)(inline_table_context_1.InlineTableFieldContext);
    const { isSubkey = true, collectionDatakey, disabled, dataHook, multiple, labelMapper, notifyChange, linkUrl, } = inlineProps;
    const { index, column } = tableFieldProps;
    const source = dataHook();
    return (react_1.default.createElement(form_autocomplete_1.FormAutocomplete, { name: isSubkey
            ? `${collectionDatakey}[${index}].${column.datakey}`
            : `${collectionDatakey}[${index}]`, source: source, multiple: multiple, labelOptions: { hide: true }, layoutOptions: { noUnderline: true }, disabled: tableDisabled ||
            (typeof disabled === 'function' ? disabled(index) : disabled), labelMapper: labelMapper, notifyChange: notifyChange, linkUrl: linkUrl }));
}
//# sourceMappingURL=inline-autocomplete-cell.js.map